/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Heading_ItalicInputs */

const et_pricing_heading_italic = /** @type {(inputs: Pricing_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rohkem Kliente`)
};

const en_pricing_heading_italic = /** @type {(inputs: Pricing_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`more Clients`)
};

/**
* | output |
* | --- |
* | "more Clients" |
*
* @param {Pricing_Heading_ItalicInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const pricing_heading_italic = /** @type {((inputs?: Pricing_Heading_ItalicInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Heading_ItalicInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_pricing_heading_italic(inputs)
	return en_pricing_heading_italic(inputs)
});